// ============================================================================
//  UPCOMING SHOWS live in src/data/shows.js (Bhaav Sangam — Delhi and
//  Chandigarh). Nothing here names a ticketed date or a BookMyShow link.
//
//  UPCOMING_EDITION is kept only for the dancers' open call (/perform/), which
//  was for the Chandigarh show.
// ============================================================================
export const UPCOMING_EDITION = {
  city: "Chandigarh",
  dateLabel: "Sunday, 25 October 2026",
  venue: "Tagore Theatre",
  venueStreet: "Sector 18",
};

// ============================================================================
//  PERFORM — open call for dancers. Closed 5 October 2026: open is false, so
//  the nav, footer and home page links are gone and /perform/ says it has
//  closed instead of showing the form. The URL stays alive for anyone holding it.
// ============================================================================
export const PERFORM = {
  open: false,
  path: "/perform",
  deadlineLabel: "5 October 2026",
  deadlineISO: "2026-10-05",
  blurb: "Solo dancers and dance groups \u2014 any style that works with bhajans.",
};

// The most recent completed edition. Used for the Delhi recap and the past
// MusicEvent in structured data — never to advertise something for sale.
export const LAST_EDITION = {
  name: "Antara — Bhajan Jamming",
  dateLabel: "Sunday, 30 August 2026",
  dateShort: "Sun · 30 Aug 2026",
  dateISO: "2026-08-30",
  city: "New Delhi",
  cityShort: "Delhi",
  venue: "M.P.C.U. Shah Auditorium",
  venueStreet: "Raj Niwas Marg, Civil Lines",
  venueLocality: "New Delhi",
  venuePostal: "110054",
  venueRegion: "Delhi",
  venueAddress:
    "M.P.C.U. Shah Auditorium, Raj Niwas Marg, Civil Lines, New Delhi 110054",
  note: "Antara's first Delhi edition",
  capacityPerShow: "700+",
  // Two shows ran on the day.
  shows: [
    { id: "matinee", label: "Matinee", time: "3:00 – 5:00 PM",
      startISO: "2026-08-30T15:00:00+05:30", endISO: "2026-08-30T17:00:00+05:30" },
    { id: "evening", label: "Evening", time: "7:00 – 9:00 PM",
      startISO: "2026-08-30T19:00:00+05:30", endISO: "2026-08-30T21:00:00+05:30" },
  ],
};

// ============================================================================
//  INTEREST LIST — the secondary CTA while shows are on sale, and the only
//  one once they have passed. Ticketing URLs live in src/data/shows.js alone;
//  scripts/verify-content.js fails the build on any other BookMyShow link.
// ============================================================================
export const INTEREST_ANCHOR = "interest";
export const INTEREST_HREF = `/#${INTEREST_ANCHOR}`;
export const INTEREST_BLURB =
  "Tell us which city you're in and we'll let you know when Antara comes to you.";

// Short links for the Instagram bio and WhatsApp, in public/_redirects:
// /city → /#interest, /host and /private → /host/, /sponsor → /sponsorship/.

// Chandigarh and Mumbai are the announced next markets and must stay visible.
export const INTEREST_CITIES = [
  "Delhi NCR",
  "Gurgaon",
  "Chandigarh",
  "Mumbai",
  "Somewhere else",
];

// General enquiry / talk-to-us WhatsApp
export const WHATSAPP_URL =
  "https://wa.me/919355322133?text=Hi%2C%20I%27d%20like%20to%20know%20about%20Antara";

export const SPONSOR_MAILTO =
  "mailto:hello@kashiwithanshu.com?subject=Antara%20Sponsorship%20Enquiry";

export const CONTACT_EMAIL = "hello@kashiwithanshu.com";

// ============================================================================
//  Brand + social
// ============================================================================
export const SITE_URL = "https://bhajanjamming.com";
export const ANTARA_IG = "https://www.instagram.com/antara.live";
export const ANTARA_IG_HANDLE = "@antara.live";
export const KASHI_IG = "https://www.instagram.com/kashiwithanshu";
export const KASHI_IG_HANDLE = "@kashiwithanshu";
export const KASHI_SITE = "https://kashiwithanshu.com";
export const IG_REEL_URL = "https://www.instagram.com/reel/DWxnH2WSmk3/";

// ============================================================================
//  Self-hosted images (compressed). PUBLIC_URL works on any subpath.
// ============================================================================
const P = process.env.PUBLIC_URL || "";

export const LOGO_URL = `${P}/img/antara-logo.png`;
// Event poster (portrait 2:3) — framed artwork, NOT a background and NOT og:image.
export const POSTER_IMG = `${P}/img/antara-poster.jpg`;
export const POSTER_ALT = "Antara — A Divine Bhajan Jamming Experience poster";
// Landscape 1200x630 social card for og:image / twitter:image.
export const OG_POSTER = `${SITE_URL}/img/antara-og.jpg`;
export const ABOUT_PHOTO = `${P}/img/about-band.jpg`;
export const DIYA_PHOTO = `${P}/img/diya-photo.jpg`;
export const CLOSING_PHOTO = `${P}/img/closing.jpg`;
export const TROUPE_PHOTO = `${P}/img/troupe.jpg`;

// Legacy stock still referenced by the Gurgaon edition records and the reel
// posters. New photography lives in src/data/gallery.json — see lib/gallery.js.
export const GALLERY_IMAGES = [
  `${P}/img/g1.jpg`, `${P}/img/g2.jpg`, `${P}/img/g3.jpg`, `${P}/img/g4.jpg`,
  `${P}/img/g5.jpg`, `${P}/img/g6.jpg`, `${P}/img/g7.jpg`, `${P}/img/g8.jpg`,
];

// Mood board kept as reference (not embedded)
export const MOOD_BOARD =
  "https://customer-assets.emergentagent.com/job_spiritual-sound-1/artifacts/7dkq4g8u_IMG-20260428-WA0003.jpg";

// ============================================================================
//  Antara videos
// ============================================================================
export const YT_VIDEO_ID = "oQAQg5tCaRQ"; // long landscape — Antara story
export const YT_SHORT_ID = "zUj08BU4QCM"; // vertical short
export const YT_TESTIMONIAL_ID = "mU_o27QHu0A"; // testimonial video
